import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "image-carousel" }
const _hoisted_2 = { class: "carousel__item" }
const _hoisted_3 = ["max"]
const _hoisted_4 = { class: "image-carousel__slider-label" }

import "vue3-carousel/dist/carousel.css";
import { Carousel, Slide } from "vue3-carousel";
import { PropType, ref } from "vue";
import TressGrid from "@/components/TressGrid.vue";
import TressRow from "@/components/TressRow.vue";
import TressColumn from "@/components/TressColumn.vue";
import IconArrowLeft from "@/components/icons/IconArrowLeft.vue";
import IconArrowRight from "@/components/icons/IconArrowRight.vue";
import { Image } from "@/models/Image";


export default /*#__PURE__*/_defineComponent({
  __name: 'TressImageCarousel',
  props: {
  list: {
    type: Object as PropType<Image[]>,
    required: true,
  },
},
  setup(__props) {

const carouselEl = ref();
const currentSlide = ref<number>(0);
const onPreviousClick = () => {
  carouselEl.value.prev();
};
const onNextClick = () => {
  carouselEl.value.next();
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Carousel), {
      ref_key: "carouselEl",
      ref: carouselEl,
      modelValue: currentSlide.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentSlide).value = $event)),
      mouseDrag: __props.list.length > 1
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list, (slide, idx) => {
          return (_openBlock(), _createBlock(_unref(Slide), {
            key: slide.id
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _renderSlot(_ctx.$slots, "default", {
                  item: slide,
                  idx: idx
                })
              ])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 3
    }, 8, ["modelValue", "mouseDrag"]),
    (__props.list.length > 1)
      ? (_openBlock(), _createBlock(TressGrid, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(TressRow, { class: "justify-content-center align-items-center image-carousel__navigation-container" }, {
              default: _withCtx(() => [
                _createVNode(TressColumn, { class: "col-auto" }, {
                  default: _withCtx(() => [
                    _createElementVNode("button", {
                      onClick: onPreviousClick,
                      class: "image-carousel__previous-button"
                    }, [
                      _createVNode(IconArrowLeft, {
                        class: _normalizeClass(["image-carousel__arrow", { 'image-carousel__arrow--disabled': currentSlide.value == 0 }])
                      }, null, 8, ["class"])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(TressColumn, {
                  class: "justify-content-center",
                  style: {"position":"relative"}
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("input", {
                      class: "image-carousel__slider",
                      type: "range",
                      min: "0",
                      max: __props.list.length - 1,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((currentSlide).value = $event)),
                      step: "1",
                      style: _normalizeStyle({ '--thumb-width': 100 / __props.list.length + '%' })
                    }, null, 12, _hoisted_3), [
                      [_vModelText, currentSlide.value]
                    ]),
                    _createElementVNode("p", _hoisted_4, _toDisplayString(+currentSlide.value + 1) + "/" + _toDisplayString(__props.list.length), 1)
                  ]),
                  _: 1
                }),
                _createVNode(TressColumn, { class: "col-auto" }, {
                  default: _withCtx(() => [
                    _createElementVNode("button", {
                      onClick: onNextClick,
                      class: "image-carousel__next-button"
                    }, [
                      _createVNode(IconArrowRight, {
                        class: _normalizeClass(["image-carousel__arrow", { 'image-carousel__arrow--disabled': currentSlide.value == __props.list.length - 1 }])
                      }, null, 8, ["class"])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})